var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AF9C81EF-B109-4A54-9B0A-F91F2AE1410E@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password-Validation",
    transform: "translate(-270.000000, -517.000000)",
    fill: "#D0021B",
    stroke: "#D0021B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.110413,522.499928 L279.873574,518.736828 C280.042142,518.568262 280.042142,518.29499 279.873574,518.126424 C279.705005,517.957859 279.431729,517.957859 279.26316,518.126424 L275.5,521.889525 L271.73684,518.127 C271.568271,517.958434 271.294995,517.958434 271.126426,518.127 C270.957858,518.295565 270.957858,518.568837 271.126426,518.737403 L274.889587,522.500503 L271.127002,526.263028 C270.958433,526.431594 270.958433,526.704866 271.127002,526.873432 C271.211573,526.957427 271.321459,527 271.431921,527 C271.542382,527 271.652843,526.958002 271.73684,526.873432 L275.5,523.110332 L279.26316,526.873432 C279.347732,526.957427 279.457618,527 279.568079,527 C279.678541,527 279.789002,526.958002 279.872998,526.873432 C280.041567,526.704866 280.041567,526.431594 279.872998,526.263028 L276.110413,522.499928 Z",
    id: "Path-Copy-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRed);
export default __webpack_public_path__ + "static/media/x-red.4a35f0704aef1e976a1dab9f535b90a1.svg";
export { ForwardRef as ReactComponent };